import { render, staticRenderFns } from "./ReportBuildingAmount.vue?vue&type=template&id=458c7659&scoped=true"
import script from "./ReportBuildingAmount.vue?vue&type=script&lang=js"
export * from "./ReportBuildingAmount.vue?vue&type=script&lang=js"
import style0 from "./ReportBuildingAmount.vue?vue&type=style&index=0&id=458c7659&prod&scoped=true&lang=css"
import style1 from "./ReportBuildingAmount.vue?vue&type=style&index=1&id=458c7659&prod&lang=css"
import style2 from "./ReportBuildingAmount.vue?vue&type=style&index=2&id=458c7659&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c7659",
  null
  
)

export default component.exports